export { default, CompanyTable } from './DataTable';
